import classNames from "classnames";
import { type StreamingProviderContent } from 'src/lib/movieinfo/movieinfotypes';
import styles from "./StreamingProvider.module.css";


//#region [Props]
type StreamingProviderProps = {
    providerContent: StreamingProviderContent;
    className?: string;
};
//#endregion

//#region [Component]
export default function StreamingProvider({ providerContent, className }: StreamingProviderProps) {
    const url = addAffiliate(providerContent.url!, providerContent.id);
    const logo = providerContent.provider?.logo?.substring(providerContent.provider?.logo?.lastIndexOf("/"));
    return <a className={classNames(styles.ProviderLink, className)} href={url} target="_blank" onClick={() => track(providerContent)}>
        <img className={styles.Img} src={`/providerlogos${logo!}`} alt={providerContent.provider?.name ?? "Innholdsleverandør"} />
    </a>;
}
//#endregion

//#region [Component]
function addAffiliate(href: string, providerId: number) {
    let newHref = href;
    switch (providerId) {
        case 26:
            newHref = `https://hbomax.prf.hn/click/camref:1011lqFg9/pubref:filmweb/ar:filmweb_SG/destination:${href.replace(/:/g, '%3A').replace(/\//g, '%2F')}`;
            //console.debug("Adding affiliate", href, newHref);
            break;
        default:
    }
    return newHref;
}

function track(providerContent: StreamingProviderContent) {
    window?.dataLayer?.push({
        'event': 'Streamingguiden',
        'eventCategory': 'Streamingklikk',
        'eventAction': providerContent.provider?.name,
        'eventLabel': providerContent.title,
        'eventStreamingId': providerContent.id
    });
}
//#endregion
